import React, { useEffect } from 'react';
import '../../styles/components/image-preview.css';

interface ImagePreviewProps {
  src: string;
  alt: string;
  isOpen: boolean;
  onClose: () => void;
}

const ImagePreview: React.FC<ImagePreviewProps> = ({ src, alt, isOpen, onClose }) => {
  // Handle escape key press
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      // Prevent background scrolling when modal is open
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="image-preview-overlay" onClick={onClose}>
      <div className="image-preview-container">
        <button 
          className="image-preview-close" 
          onClick={onClose}
          aria-label="Close image preview"
        >
          ×
        </button>
        <img 
          src={src} 
          alt={alt} 
          className="image-preview-image"
          onClick={onClose} // Allow closing when clicking the image
        />
      </div>
    </div>
  );
};

export default ImagePreview; 